import { APIClient } from '@/services'
import { Image } from './Image'
import { theme } from '@/config'

export function CompanyLogo(props: Partial<React.ComponentPropsWithoutRef<typeof Image>>) {
  const branding = APIClient.Session.useCompanyBranding()

  if (!branding?.logo) return null

  const isSvg = branding.logo.toLowerCase().endsWith('.svg')

  return <Image
    source={branding.logo}
    {...props}
    style={[{ aspectRatio: 1, width: theme.size.large }, props.style]}
    // SVG images work with regular img tags in web, but this flag allows for future special handling
    data-is-svg={isSvg}
  />
}
